<template>
  <el-dialog
    :title="$t('eventList.SPV')"
    :visible.sync="dialogVisible"
    width="70%"
    class="qdVerifyDialog"
    @close="dialogCloseHandle"
  >
    <div class="common_group" v-if="!$store.state.userInfo.belongToSmb">
      <div class="title">
        <img src="@/assets/images/costIcon.png">
        <span>{{ $t('eventList.CI') }}</span>
        <div class="buttonBar">
          <el-button
            v-if="rowData.stat === 50 || rowData.stat === 60"
            type="primary"
            @click="billsPrintHandler"
          >
            {{ $t('eventList.Print') }}
          </el-button>
        </div>
      </div>
      <commonTable ref="qdVerifyInformationTable" />
    </div>
    <div class="common_group">
      <div class="title">
        <img src="@/assets/images/informationIcon.png">
        <span>{{ $t('eventList.Doa') }}</span>
        <div class="buttonBar">
          <el-button type="primary" @click="addRow" v-if="!readOnly">{{ $t('newApp.Attribute.aar') }}</el-button>
        </div>
      </div>
      <commonTable
        ref="qdVerifyDetailedTable"
        :footer-cost="{ label: $t('eventList.Tac'), val: Number(totalMoney).toFixed(2) }"
      />
    </div>
    <div class="common_group">
      <div class="title">
        <img src="@/assets/images/fileIcon.png">
        <span>{{ $t('eventList.Au') }}</span>
        <span v-if="rowData.expenseTypeCode === 'EI172'" class="tips-info">
          请上传发票、签到表和活动现场照片，如无请说明情况
        </span>
      </div>
      <el-upload
        class="uploadFile"
        :action="baseUrl"
        :on-remove="invoiceFileRemove"
        :before-upload="beforeUpload"
        :on-success="invoiceFileSuccess"
        :on-preview="filePreview"
        multiple
        :file-list="invoiceFileList"
        :disabled="readOnly"
      >
        <el-button type="primary" :disabled="readOnly">{{ $t('eventList.Uei') }}</el-button>
      </el-upload>
      <el-upload
        class="uploadFile"
        :action="baseUrl"
        :on-remove="otherFileRemove"
        :before-upload="beforeUpload"
        :on-success="otherFileSuccess"
        :on-preview="filePreview"
        multiple
        :file-list="otherFileList"
        :disabled="readOnly"
      >
        <el-button type="primary" :disabled="readOnly">{{ $t('eventList.NonI') }}</el-button>
      </el-upload>
      <div v-if="rowData.expenseTypeCode === 'EI172'" class="remark-input">
        原因说明：<el-input
          type="remark"
          :rows="2"
          placeholder="请输入原因说明"
          maxlength="100"
          v-model="remark"
          :disabled="readOnly"
        />
      </div>
    </div>
    <billsCreateDialog
      :dialog-show="billsCreateDialogShow"
      :print-data="printData"
      @dialogCloseHandle="billsCreateDialogShow = false"
    />
    <div v-if="!readOnly" slot="footer" class="dialog-footer">
      <el-button plain @click="dialogCloseHandle">{{ $t('btn.Cancel') }}</el-button>
      <el-button type="primary" @click="submitHandle">{{ $t('btn.OK') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import commonTable from 'components/commonTable';
import { TableColumns, TableRow } from '@/utils/tableOptions';
import { newApplicationFormApi } from '@/views/newApplicationForm/service';
import { activistyCostAttribution } from '../../../service';
import { arrayQuery } from '@/utils/utils';
import billsCreateDialog from './billsCreateDialog.vue';
import { isNotEmpty, throttle } from '../../../../../utils/utils';
export default {
  data () {
    return {
      dialogVisible: false,
      basicDataList: [{}],
      detailedList: [],
      projectConentList: [],
      totalMoney: 0,
      invoiceFileList: [],
      otherFileList: [],
      baseUrl: '',
      depositBankList: [],
      depositBranchList: [],
      bankRegionList: [],
      bankCityList: [],
      readOnly: true,
      billsCreateDialogShow: false,
      expenseBelongId: '',
      printData: {},
      remark: ''
    };
  },
  props: {
    qdVerifyVisible: {
      type: Boolean,
      default: false
    },
    echoData: {
      type: Object,
      default: () => {
        return {};
      }
    },
    rowData: {
      type: Object,
      default: () => {
        return {};
      }
    },
    dialogSubmitHandle: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  components: {
    commonTable,
    billsCreateDialog
  },
  filters: {
    totalMoneyFilter (val) {
      return Number(val).toFixed(2);
    }
  },
  watch: {
    qdVerifyVisible (val) {
      console.log(val);
      if (val) {
        // 状态（ -1-删除  0-草稿  10-审批中 20-驳回  30-待反馈  40-待核销  50-核销中 55-核销驳回（渠道） 60-核销结束  70-召回  80-撤销 ）
        this.readOnly = this.rowData.stat === 50 || this.rowData.stat === 60;
        if (
          this.rowData.stat === 55 ||
          this.rowData.stat === 50 ||
          this.rowData.stat === 60
        ) {
          this.getQdVerifyEchoData();
        } else {
          // smb不需要收款账号信息
          if (!this.$store.state.userInfo.belongToSmb) {
            this.loadBasicDataTable();
            this.getBillingData();
          }
          this.detailedList = this.rowData.activityExpenseDetails.map(item => {
            return {
              content: item.content,
              amount: item.amount,
              price: item.price
            };
          });
          this.loadDetailedDataTable();
        }
        this.getExpenseOptionList();
        this.getDepositBankList();
      } else {
        this.basicDataList = [{}];
        this.detailedList = [];
        this.invoiceFileList = [];
        this.otherFileList = [];
      }
      this.dialogVisible = val;
    }
  },
  methods: {
    billsPrintHandler () {
      this.$store.commit('setSubPageLoading', true);
      activistyCostAttribution.getPrintData(this.expenseBelongId).then(res => {
        this.$store.commit('setSubPageLoading', false);
        if (res.status === '200') {
          let result = res.data;
          result.realPayAmount = result.realPayAmount
            ? result.realPayAmount
            : result.applyAmount;
          result.realPayAmountBig = result.realPayAmountBig
            ? result.realPayAmountBig
            : result.applyAmountBig;
          result.writeOffAmount = result.writeOffAmount
            ? result.writeOffAmount
            : result.applyAmount;
          this.printData = result;
          this.billsCreateDialogShow = true;
        }
      });
    },
    filePreview (file) {
      let fileId = '';
      if (file.fileId) {
        fileId = file.fileId;
      } else {
        fileId = file.response.data[0].FID;
      }
      activistyCostAttribution.getFilePreviewUrl(fileId).then(res => {
        if (res.status === '200') {
          let link = document.createElement('a');
          link.style.display = 'none';
          link.href = res.data;
          link.target = '_blank';
          link.setAttribute('download', '');
          document.body.appendChild(link);
          link.click();
        }
      });
    },
    getHistoryData () {
      return new Promise((resolve, reject) => {
        activistyCostAttribution
          .getHistoryData(this.$store.state.userInfo.sysUser.userId)
          .then(res => {
            if (res.status === '200') {
              let { data } = res;
              if (data) {
                resolve({
                  bankName: data.bankName,
                  bankCode: data.bankCode,
                  province: data.province,
                  city: data.city,
                  cityCode: data.cityCode,
                  branchCode: data.branchCode,
                  branchName: data.branchName
                });
              } else {
                resolve({});
              }
            }
          });
      });
    },
    beforeUpload (file) {
      return new Promise((resolve, reject) => {
        let fileSize = file.size / 1024 / 1024 < 10;
        if (!fileSize) {
          this.$message.error(this.$t('file.uFn10M'));
          reject(new Error(this.$t('file.uFn10M')));
          return false;
        }
        activistyCostAttribution.getFinancialUploadUrl().then(res => {
          if (res.status === '200') {
            this.baseUrl = res.data;
            resolve();
          } else {
            reject(res.status);
          }
        });
      });
    },
    invoiceFileSuccess (response, file, fileList) {
      if (response.status === '200') {
        this.invoiceFileList = fileList;
      } else {
        this.$message.error(response.err);
        this.invoiceFileList = fileList.filter(item => {
          return file.name !== item.name;
        });
      }
      this.baseUrl = '';
    },
    otherFileSuccess (response, file, fileList) {
      if (response.status === '200') {
        this.otherFileList = fileList;
      } else {
        this.$message.error(response.err);
        this.otherFileList = fileList.filter(item => {
          return file.name !== item.name;
        });
      }
      this.baseUrl = '';
    },
    invoiceFileRemove (file, fileList) {
      if (file && file.status === 'success') {
        this.invoiceFileList = fileList;
        this.$message({
          type: 'success',
          message: this.$t('general.DeleSucc')
        });
      }
    },
    otherFileRemove (file, fileList) {
      if (file && file.status === 'success') {
        this.otherFileList = fileList;
        this.$message({
          type: 'success',
          message: this.$t('general.DeleSucc')
        });
      }
    },
    addRow () {
      this.$refs.qdVerifyDetailedTable.insertRow({ addFlag: 1 });
    },
    submitHandle: throttle(function () {
      if (this.submitValidate()) {
        let basicData = this.basicDataList[0];
        // 活动明细
        let activityExpenseWriteOffList = this.detailedList.map(item => {
          return {
            id: item.id ? item.id : '',
            expenseBelongId: this.rowData.id,
            content: item.content,
            price: item.price,
            amount: item.amount,
            total: Number(item.price) * Number(item.amount),
            actualPrice: item.actualPrice,
            actualAmount: item.actualAmount,
            actualTotal: Number(item.actualTotal)
          };
        });
        let borrowingVO = {
          expenseBelongId: this.rowData.id,
          activityCode: this.rowData.activityCode,
          applyUserId: this.rowData.salerId,
          verifiUserId: this.rowData.salerId,
          deptCode: this.rowData.deptCode,
          deptName: this.rowData.deptName,
          expenseTypeCode: this.rowData.expenseTypeCode,
          expenseType: this.rowData.expenseType,
          borrowMoney: this.rowData.applyAmount,
          borrowPurpose: this.rowData.note,
          currencyCode: this.echoData.marketActivity.currencyCode,
          instanceComCode: this.echoData.marketActivity.financialSystemCode,
          totalCost: this.totalMoney,
          reveivable: {
            accountType: 2,
            receivableAmount: this.totalMoney
          },
          activityCostBreakdown: activityExpenseWriteOffList,
          electronicInvoice:
            this.invoiceFileList.length > 0
              ? this.invoiceFileList.map(item => {
                  return {
                    fileId: item.response
                      ? item.response.data[0].FID
                      : item.fileId,
                    fileName: item.name
                  };
                })
              : [],
          filesInfo:
            this.otherFileList.length > 0
              ? this.otherFileList.map(item => {
                  return {
                    fileId: item.response
                      ? item.response.data[0].FID
                      : item.fileId,
                    fileName: item.name
                  };
                })
              : []
        };
        let qdWriteOff = {
          activityCode: this.rowData.activityCode,
          expenseBelongId: this.rowData.id,
          qdBillingId: this.$store.state.userInfo.sysUser.userId,
          partnerCode: this.$store.state.userInfo.sysUser.userId,
          remark: this.remark
        };
        if (this.rowData.stat === 55) {
          // 如果是驳回编辑提交，需要把核销单号传回去
          qdWriteOff.writeOffCode = basicData.writeOffCode;
        }
        // 如果不是smb，则添加收款信息
        if (!this.$store.state.userInfo.belongToSmb) {
          borrowingVO = {
            ...borrowingVO,
            bankName: basicData.bankName,
            bankCode: basicData.bankCode,
            bankAccount: basicData.bankAcount,
            branchName: basicData.branchName,
            branchCode: basicData.branchCode,
            reveivable: {
              ...borrowingVO.reveivable,
              accountName: basicData.partnerName,
              accountNo: basicData.bankAcount,
              bankName: basicData.bankName,
              bankCode: basicData.bankCode,
              branchBankName: basicData.branchName,
              branchBankCode: basicData.branchCode,
              province: basicData.province,
              city: basicData.city,
              cityCode: basicData.cityCode
            }
          };
          qdWriteOff = {
            ...qdWriteOff,
            partnerName: basicData.partnerName,
            bankAcountName: basicData.partnerName,
            bankAcount: basicData.bankAcount,
            bankCode: basicData.bankCode,
            bankName: basicData.bankName,
            province: basicData.province,
            city: basicData.city,
            cityCode: basicData.cityCode,
            branchName: basicData.branchName,
            branchCode: basicData.branchCode,
            taxPayerCode: basicData.taxPayerCode
          };
        }
        this.$emit('dialogSubmitHandle', {
          borrowingVO,
          qdWriteOff,
          activityExpenseWriteOffList
        });
      }
    }, 1000),
    dialogCloseHandle () {
      this.remark = '';
      this.$emit('dialogCloseHandle');
    },
    deleteBtn (row) {
      this.$refs.qdVerifyDetailedTable.removeRow(row);
      this.moneyCount(row);
    },
    moneyCount (row) {
      row.actualPrice = row.actualPrice ? Number(row.actualPrice) : 0;
      row.actualAmount = row.actualAmount ? Number(row.actualAmount) : 0;
      row.actualTotal = (row.actualPrice * row.actualAmount).toFixed(2);
      this.totalMoney = this.detailedList.reduce((current, item) => {
        return current + Number(item.actualTotal ? item.actualTotal : 0);
      }, 0);
    },
    submitValidate () {
      // // 收款信息效验
      let basicData = this.basicDataList[0];
      if (
        (!basicData.bankCode ||
          !basicData.bankName ||
          !basicData.province ||
          !basicData.city ||
          !basicData.cityCode ||
          !basicData.branchCode ||
          !basicData.branchName) &&
        !this.$store.state.userInfo.belongToSmb
      ) {
        this.$message.error(this.$t('eventList.Pctpi'));
        return;
      }
      // 活动明细效验
      if (this.detailedList.length > 0) {
        for (let i = 0; i < this.detailedList.length; i++) {
          let current = this.detailedList[i];
          if (current.addFlag && !current.content) {
            this.$message.error(this.$t('newApp.Attribute.pspc'));
            return;
          }
          if (!current.actualPrice) {
            this.$message.error(this.$t('eventList.Peaup'));
            return;
          }
          if (!current.actualAmount) {
            this.$message.error(this.$t('eventList.Peaq'));
            return;
          }
        }
      }
      return true;
    },
    getQdVerifyEchoData () {
      activistyCostAttribution
        .getQdVerifyData(this.rowData.id)
        .then(async res => {
          if (res.status === '200') {
            // 收款信息
            this.basicDataList = [res.data.qdWriteOff];
            // 如果渠道不是smb
            if (!this.$store.state.userInfo.belongToSmb) {
              this.bankRegionList = await this.getRegionWhereBankList();
              if (isNotEmpty(this.basicDataList) && isNotEmpty(this.basicDataList[0]) && this.basicDataList[0].province) {
                let regionObj = arrayQuery(
                  this.basicDataList[0].province,
                  this.bankRegionList,
                  'provinceName'
                );
                this.bankCityList = regionObj.citys ? regionObj.citys : [];
              }
              this.remark = res.data.qdWriteOff.remark; // 备注
              this.getDepositBranchList(res.data.qdWriteOff);
              this.loadBasicDataTable();
            }

            // 活动明细
            this.detailedList = isNotEmpty(res.data.activityExpenseWriteOffList) ? res.data.activityExpenseWriteOffList : [];
            if (isNotEmpty(this.detailedList)) {
              this.totalMoney = this.detailedList.reduce((current, item) => {
                return current + Number(item.actualTotal ? item.actualTotal : 0);
              }, 0);
              if (this.detailedList[0]) {
                this.expenseBelongId = this.detailedList[0].expenseBelongId;
              }
            }
            // 附件上传
            this.invoiceFileList =
            isNotEmpty(res.data.electronicInvoice)
                ? res.data.electronicInvoice.map(item => {
                    item.name = item.fileName;
                    return item;
                  })
                : [];
            this.otherFileList =
              isNotEmpty(res.data.filesInfo)
                ? res.data.filesInfo.map(item => {
                    item.name = item.fileName;
                    return item;
                  })
                : [];
            this.loadDetailedDataTable();
          }
        });
    },
    loadBasicDataTable () {
      let tableRow = new TableRow();
      tableRow.push(
        new TableColumns()
          ._width('10%')
          ._title(this.$t('eventList.PaymentType'))
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
              return this.$t('eventList.BankPayment');
            }
          })
      );
      tableRow.push(
        new TableColumns()
          ._width('10%')
          ._title(this.$t('eventList.AccountType'))
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
              return this.$t('eventList.ExternalUnit');
            }
          })
      );
      tableRow.push(
        new TableColumns()
          ._width('10%')
          ._title(this.$t('eventList.Ban'))
          ._data('partnerName')
      );
      if (this.readOnly) {
        tableRow.push(
          new TableColumns()
            ._width('10%')
            ._title(this.$t('eventList.AccountBank'))
            ._data('bankName')
        );
        tableRow.push(
          new TableColumns()
            ._width('12%')
            ._title(this.$t('eventList.Pwtbil'))
            ._data('province')
        );
        tableRow.push(
          new TableColumns()
            ._width('10%')
            ._title(this.$t('eventList.Cwtbil'))
            ._data('city')
        );
        tableRow.push(
          new TableColumns()
            ._width('10%')
            ._title(this.$t('eventList.Aob'))
            ._data('branchName')
        );
      } else {
        tableRow.push(
          new TableColumns()
            ._width('10%')
            ._title(this.$t('eventList.AccountBank'))
            ._data('bankCode')
            ._cellType('customSelect')
            ._cellData({
              filterable: true,
              options: this.depositBankList,
              optionProps: {
                label: 'bankName',
                value: 'bankCode'
              },
              events: {
                change: ({ row, value }) => {
                  let bankObj = arrayQuery(
                    value,
                    this.depositBankList,
                    'bankCode'
                  );
                  row.bankName = bankObj.bankName;
                  // 清空支行
                  row.branchCode = '';
                  this.depositBranchList = [];
                }
              }
            })
        );
        tableRow.push(
          new TableColumns()
            ._width('12%')
            ._title(this.$t('eventList.Pwtbil'))
            ._data('province')
            ._cellType('customSelect')
            ._cellData({
              filterable: true,
              options: this.bankRegionList,
              optionProps: {
                label: 'provinceName',
                value: 'provinceName'
              },
              events: {
                change: ({ row, value }) => {
                  // 清空城市
                  row.city = '';
                  this.bankCityList = [];
                  // 清空支行
                  row.branchCode = '';
                  this.depositBranchList = [];

                  let regionObj = arrayQuery(
                    value,
                    this.bankRegionList,
                    'provinceName'
                  );
                  this.bankCityList = regionObj.citys ? regionObj.citys : [];
                  this.loadBasicDataTable();
                }
              }
            })
        );
        tableRow.push(
          new TableColumns()
            ._width('10%')
            ._title(this.$t('eventList.Cwtbil'))
            ._data('city')
            ._cellType('customSelect')
            ._cellData({
              filterable: true,
              options: this.bankCityList,
              optionProps: {
                label: 'cityName',
                value: 'cityName'
              },
              events: {
                focus: ({ row }) => {
                  if (!row.province) {
                    this.$message.error(this.$t('eventList.Psyp'));
                  }
                },
                change: ({ row }) => {
                  row.branchCode = '';
                  this.depositBranchList = [];
                  this.$refs.qdVerifyInformationTable.refreshColumn();
                }
              }
            })
        );
        tableRow.push(
          new TableColumns()
            ._width('10%')
            ._title(this.$t('eventList.Aob'))
            ._data('branchCode')
            ._cellType('customSelect')
            ._cellData({
              filterable: true,
              options: this.depositBranchList,
              optionProps: {
                label: 'branchName',
                value: 'branchCode'
              },
              events: {
                focus: ({ row }) => {
                  this.getDepositBranchList(row);
                },
                change: ({ row, value }) => {
                  let bankObj = arrayQuery(
                    value,
                    this.depositBranchList,
                    'branchCode'
                  );
                  row.branchName = bankObj.branchName;
                  row.cityCode = bankObj.cityCode;
                  this.$refs.qdVerifyInformationTable.refreshColumn();
                }
              }
            })
        );
      }
      tableRow.push(
        new TableColumns()
          ._width('10%')
          ._title(this.$t('eventList.Ban'))
          ._data('bankAcount')
      );
      tableRow.push(
        new TableColumns()
          ._width('10%')
          ._title(this.$t('eventList.TIn'))
          ._data('taxPayerCode')
      );
      let column = tableRow._cols();
      this.$nextTick(() => {
        this.$refs.qdVerifyInformationTable.setColumn(column, {
          page: false
        });
        this.$refs.qdVerifyInformationTable.loadStaticTable(this.basicDataList);
      });
    },
    loadDetailedDataTable () {
      let tableRow = new TableRow();
      tableRow.push(
        new TableColumns()
          ._title(this.$t('newApp.Attribute.pc'))
          ._data('content')
          ._width('15%')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
              let elementObj = <span>{row.content}</span>;
              if (row.addFlag && !this.readOnly) {
                elementObj = (
                  <el-select v-model={row.content}>
                    {this.projectConentList.map((item, index) => {
                      return (
                        <el-option
                          key={index}
                          label={item.fieldValue}
                          value={item.fieldValue}
                        ></el-option>
                      );
                    })}
                  </el-select>
                );
              }
              return elementObj;
            }
          })
      );
      tableRow.push(
        new TableColumns()
          ._width('15%')
          ._title(this.$t('newApp.Attribute.pup'))
          ._data('price')
      );
      tableRow.push(
        new TableColumns()
          ._width('10%')
          ._title(this.$t('newApp.Attribute.nop'))
          ._data('amount')
      );
      if (this.readOnly) {
        tableRow.push(
          new TableColumns()
            ._width('8%')
            ._title(this.$t('eventList.Aup'))
            ._data('actualPrice')
        );
        tableRow.push(
          new TableColumns()
            ._width('8%')
            ._title(this.$t('eventList.ActualN'))
            ._data('actualAmount')
        );
      } else {
        tableRow.push(
          new TableColumns()
            ._title(this.$t('eventList.Aup'))
            ._data('actualPrice')
            ._width('15%')
            ._cellType('customDom')
            ._cellData({
              formater: ({ row, column }) => {
                return (
                  <el-input-number
                    v-model={row[column.property]}
                    min={0}
                    controls={false}
                    precision={2}
                    onChange={() => {
                      this.moneyCount(row);
                    }}
                  />
                );
              }
            })
        );
        tableRow.push(
          new TableColumns()
            ._title(this.$t('eventList.ActualN'))
            ._data('actualAmount')
            ._width('15%')
            ._cellType('customDom')
            ._cellData({
              formater: ({ row, column }) => {
                return (
                  <el-input-number
                    v-model={row[column.property]}
                    min={0}
                    precision={0}
                    onChange={() => {
                      this.moneyCount(row);
                    }}
                  />
                );
              }
            })
        );
      }
      tableRow.push(
        new TableColumns()
          ._title(this.$t('eventList.ActualS'))
          ._data('actualTotal')
          ._width('15%')
      );
      if (!this.readOnly) {
        tableRow.push(
          new TableColumns()
            ._title(this.$t('general.Operation'))
            ._width('8%')
            ._cellType('customDom')
            ._cellData({
              formater: ({ row, column }) => {
                return (
                  <div>
                    {row.addFlag ? (
                      <el-button
                        type="text"
                        onClick={() => {
                          this.deleteBtn(row);
                        }}
                      >
                        {this.$t('btn.Delete')}
                      </el-button>
                    ) : null}
                  </div>
                );
              }
            })
        );
      }
      let column = tableRow._cols();
      this.$nextTick(() => {
        this.$refs.qdVerifyDetailedTable.setColumn(column, {
          page: false
        });
        this.$refs.qdVerifyDetailedTable.loadStaticTable(this.detailedList);
      });
    },
    getExpenseOptionList () {
      newApplicationFormApi.getExpenseOptionList().then(res => {
        if (res.status === '200') {
          this.projectConentList = res.data;
          this.loadDetailedDataTable();
        }
      });
    },
    getBillingData () {
      let params = this.$store.state.userInfo.sysUser.userId;
      activistyCostAttribution.getBillingData(params).then(async res => {
        if (res.status === '200') {
          let historyData = await this.getHistoryData();
          this.basicDataList = [
            {
              ...res.data,
              ...historyData
            }
          ];
          this.bankRegionList = await this.getRegionWhereBankList();
          if (isNotEmpty(this.basicDataList) && isNotEmpty(this.basicDataList[0]) && this.basicDataList[0].province) {
            let regionObj = arrayQuery(
              this.basicDataList[0].province,
              this.bankRegionList,
              'provinceName'
            );
            this.bankCityList = regionObj.citys ? regionObj.citys : [];
            this.getDepositBranchList(this.basicDataList[0]);
          }
          this.loadBasicDataTable();
        }
      });
    },
    getDepositBankList () {
      if (this.$store.state.userInfo.belongToSmb) {
        return;
      }
      activistyCostAttribution.getDepositBankList().then(res => {
        if (res.status === '200') {
          this.depositBankList = res.data;
          this.loadBasicDataTable();
        }
      });
    },
    getRegionWhereBankList () {
      return new Promise(resolve => {
        activistyCostAttribution.getRegionWhereBankList().then(res => {
          if (res.status === '200') {
            resolve(res.data);
          }
        });
      });
    },
    getDepositBranchList (params) {
      if (!isNotEmpty(params)) {
        return;
      }
      if (!params.bankCode) {
        console.log(this.$t('eventList.Psyb'));
        return;
      }
      if (!params.province) {
        console.log(this.$t('eventList.Pstpwtbil'));
        return;
      }
      if (!params.city) {
        console.log(this.$t('eventList.Pstcwtbil'));
        return;
      }
      activistyCostAttribution.getDepositBranchList(params).then(res => {
        if (res.status === '200') {
          this.depositBranchList = res.data;
          this.loadBasicDataTable();
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.common_group > .uploadFile + .uploadFile {
  margin-top: 16px;
}
.tips-info{
  color: #F56C6C !important;
}
.remark-input{
  width: 100%;
  display: flex;
  align-items: center;
  margin: 15px 0;
  .el-input{
    flex: 1;
  }
}
</style>
